import { useEffect } from "react";
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";

const NotificationHandler = () => {


 const sendTokenToBackend = async (fcmToken) => {
  try {
    const userId = parseInt(localStorage.getItem("UserId"));
     const token = localStorage.getItem("accesstoken");

    console.log("UserId:", userId);

    if (!userId || isNaN(userId)) {
      console.log("Invalid userId, skipping...");
      return;
    }

    const payload = {
      id: userId,
      Fire_Base_Token: fcmToken,
    };

    console.log("Sending payload:", payload);

    const res = await axios.patch(
      `${BASE_URL}/Felix/Usersignup/`,
      payload,
      {
          headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
      }
    );

    console.log("Token sent to backend:", res.data);

  } catch (error) {
    console.error("Error sending token:", error.response || error);
  }
};

  const enableNotifications = async () => {
    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        console.log("Permission granted");

        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
        );

        const token = await getToken(messaging, {
          vapidKey: "BAiB0njMYh0oFFYx6R-X2dbZeMZqrI3yamdaPaplJOoJgGpU-8l77xGgTRsOol7GUAHnIizS3QMVMn5zkIZ6TrM",
          serviceWorkerRegistration: registration,
        });

        console.log("FCM Token:", token);
        

        //  Just send directly
        if (token) {
          await sendTokenToBackend(token);
        }
      } else {
        console.log("Permission denied");
      }
    } catch (error) {
      console.error("Notification error:", error);
    }
  };

  useEffect(() => {
    enableNotifications();
  }, []);

  return null;
};

export default NotificationHandler;
